import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var GlobeIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12zm20 0c0-.687-.077-1.357-.223-2h-3.876c.064.633.099 1.299.099 2 0 .7-.035 1.367-.099 2h3.876A9.033 9.033 0 0021 12zm-6.11 2H9.11c-.07-.623-.11-1.289-.11-2 0-.711.04-1.377.11-2h5.78c.07.623.11 1.289.11 2 0 .711-.04 1.377-.11 2zm1.692-6h3.482a9.026 9.026 0 00-5.369-4.59c.758 1.14 1.461 2.664 1.887 4.59zM12 3.27c.793.75 1.905 2.28 2.528 4.73H9.472c.623-2.45 1.735-3.98 2.528-4.73zM14.528 16c-.624 2.45-1.735 3.98-2.528 4.73-.793-.75-1.904-2.28-2.528-4.73h5.056zm.167 4.59c.758-1.14 1.461-2.664 1.887-4.59h3.482a9.026 9.026 0 01-5.369 4.59zM7 12c0-.701.035-1.367.099-2H3.223a9.029 9.029 0 000 4h3.876A19.82 19.82 0 017 12zm.418-4c.426-1.926 1.13-3.45 1.887-4.59A9.026 9.026 0 003.935 8h3.483zm-3.482 8h3.482c.426 1.926 1.13 3.45 1.887 4.59A9.025 9.025 0 013.935 16z",
                        fillRule: "evenodd",
                        clipRule: "evenodd"
                    })
                })
            })
        ]
    });
};
GlobeIcon.isCarinaIcon = true;
export default GlobeIcon;
